"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var element_resize_event_1 = __importStar(require("element-resize-event"));
var StackView_1 = require("../../StackView");
var View_1 = require("../../View");
var SplitSeparator_1 = require("./SplitSeparator");
var Popover_1 = require("../../Popover");
var core_1 = require("@veeam/core");
var SplitLayoutInteractor_1 = require("./SplitLayoutInteractor");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var Section = styled_components_1.default.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-shrink: 1;\n    flex-grow: initial;\n    justify-self: stretch;\n    z-index: 1;\n    overflow: hidden;\n"], ["\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-shrink: 1;\n    flex-grow: initial;\n    justify-self: stretch;\n    z-index: 1;\n    overflow: hidden;\n"])));
function sizeToString(value) {
    if (!value) {
        return;
    }
    if (Number.isNaN(value)) {
        return;
    }
    if (Number.isInteger(value) || value >= 1) {
        return value + "px";
    }
    return value * 100 + "%";
}
function getSectionStyles(config, modelValue, isColumnDirection) {
    var _a, _b, _c, _d;
    var size = isColumnDirection ? (_a = modelValue === null || modelValue === void 0 ? void 0 : modelValue.height) !== null && _a !== void 0 ? _a : 0 : (_b = modelValue === null || modelValue === void 0 ? void 0 : modelValue.width) !== null && _b !== void 0 ? _b : 0;
    var hasSize = (_c = config === null || config === void 0 ? void 0 : config.size) !== null && _c !== void 0 ? _c : 0 > 0;
    var hasGrow = !hasSize && !(modelValue === null || modelValue === void 0 ? void 0 : modelValue.shouldApply);
    return {
        flexGrow: hasGrow ? 1 : 0,
        flexBasis: (modelValue === null || modelValue === void 0 ? void 0 : modelValue.shouldApply) ? sizeToString(size)
            : (_d = sizeToString(config === null || config === void 0 ? void 0 : config.size)) !== null && _d !== void 0 ? _d : '50%',
        minWidth: sizeToString(config === null || config === void 0 ? void 0 : config.minSize),
        maxWidth: sizeToString(config === null || config === void 0 ? void 0 : config.maxSize)
    };
}
function SplitLayout(_a) {
    var _b = _a.direction, direction = _b === void 0 ? StackView_1.STACK_DIRECTION.row : _b, start = _a.start, end = _a.end, startConfig = _a.startConfig, endConfig = _a.endConfig, _c = _a.resizable, resizable = _c === void 0 ? true : _c, onSizeChange = _a.onSizeChange, rest = __rest(_a, ["direction", "start", "end", "startConfig", "endConfig", "resizable", "onSizeChange"]);
    var configModel = core_1.useModelBuilder({
        startLimit: { minSize: (startConfig === null || startConfig === void 0 ? void 0 : startConfig.minSize) || 0, maxSize: (startConfig === null || startConfig === void 0 ? void 0 : startConfig.maxSize) || 0 },
        endLimit: { minSize: (endConfig === null || endConfig === void 0 ? void 0 : endConfig.minSize) || 0, maxSize: (endConfig === null || endConfig === void 0 ? void 0 : endConfig.maxSize) || 0 }
    }, [startConfig, endConfig]);
    var _d = Popover_1.useMeasureClientRect(), rootRef = _d[0], measureManager = _d[1];
    var _e = Popover_1.useMeasureClientRect(), startRef = _e[0], startMeasureManager = _e[1];
    var endRef = Popover_1.useMeasureClientRect()[0];
    var interactor = core_1.useInteractor(function () {
        return new SplitLayoutInteractor_1.SplitLayoutInteractor(configModel);
    }).interactor;
    react_1.useEffect(function () {
        var rootStream = new rxjs_1.Observable(function (subscriber) {
            var cb = function () {
                subscriber.next(true);
            };
            if (rootRef.current) {
                element_resize_event_1.default(rootRef.current, cb);
            }
            return function () {
                if (rootRef.current) {
                    element_resize_event_1.unbind(rootRef.current, cb);
                }
            };
        });
        var sub = interactor.sizeModel
            .asObservable()
            .pipe(operators_1.switchMap(function (v) {
            return rootStream.pipe(operators_1.startWith(true), operators_1.map(function () { return v; }));
        }))
            .subscribe(function (value) {
            requestAnimationFrame(function () {
                var _a, _b, _c;
                if (typeof window !== 'undefined' && startRef.current) {
                    var rootSize = measureManager.measure();
                    var rootWidth = (_a = rootSize === null || rootSize === void 0 ? void 0 : rootSize.width) !== null && _a !== void 0 ? _a : 0;
                    var rootHeight = (_b = rootSize === null || rootSize === void 0 ? void 0 : rootSize.height) !== null && _b !== void 0 ? _b : 0;
                    Object.assign(startRef.current.style, getSectionStyles(startConfig, value, direction === StackView_1.STACK_DIRECTION.column));
                    Object.assign((_c = endRef.current) === null || _c === void 0 ? void 0 : _c.style, getSectionStyles(endConfig, __assign(__assign({}, value), { width: rootWidth - value.width, height: rootHeight - value.height }), direction === StackView_1.STACK_DIRECTION.column));
                }
            });
        });
        return function () {
            sub.unsubscribe();
        };
    }, []);
    interactor.presenter = {
        measureRootBox: function () {
            return measureManager.measure() || { width: 0, height: 0 };
        },
        measureStartBox: function () {
            return startMeasureManager.measure() || { width: 0, height: 0 };
        }
    };
    interactor.onSizeChange = onSizeChange;
    var startStyles = getSectionStyles(startConfig, interactor.sizeModel.getValue(), direction === StackView_1.STACK_DIRECTION.column);
    var endStyles = getSectionStyles(endConfig);
    if (interactor.sizeModel.getValue().shouldApply) {
        endStyles.flexGrow = 1;
    }
    return (react_1.default.createElement(StackView_1.StackView, { ref: rootRef, direction: direction, spaceFill: View_1.SPACE_FILL.all, "data-selector-id": rest['data-selector-id'] || 'split-layout', "data-split-layout": true, root: true },
        !!start && (react_1.default.createElement(Section, { ref: startRef, style: startStyles }, start)),
        react_1.default.createElement(SplitSeparator_1.SplitSeparator, { isRow: direction === StackView_1.STACK_DIRECTION.row, onDragStart: interactor.didResizeStart, onDragEnd: interactor.didResizeEnd, onMouseMove: interactor.didMouseMove, resizable: resizable }),
        !!end && (react_1.default.createElement(Section, { ref: endRef, style: endStyles }, end))));
}
exports.SplitLayout = SplitLayout;
var templateObject_1;
//# sourceMappingURL=SplitLayout.js.map